import { Outlet } from 'react-router';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { navLabels } from '@sorare/core/src/lib/glossary';
import { EnsureTopVisibleOnMount } from '@sorare/core/src/routing/EnsureTopVisibleOnMount';
import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

const InviteLayout = () => {
  const { isIosApp } = useIsMobileApp();

  return (
    <>
      {!isIosApp && <PageHeader text={navLabels.inviteFriends} />}
      <AppLayout>
        <EnsureTopVisibleOnMount>
          <Outlet />
        </EnsureTopVisibleOnMount>
      </AppLayout>
    </>
  );
};

export default InviteLayout;
